import React, { useMemo } from 'react'
import styles from './OrderPoint.module.css'
import { useTranslation } from 'react-i18next'
import { ReactComponent as UpIcon } from 'assets/icons/up.svg'
import { ReactComponent as DownIcon } from 'assets/icons/down.svg'
import { ReactComponent as TrashIcon } from 'assets/icons/trash.svg'
import { useField } from 'formik'
import { IconButton } from './IconButton'
import { DeliveryPointForm } from './DeliveryPointForm'
import { OrderPointType } from './OrderPointType'
import { FerryPassageForm } from './FerryPassageForm'
import { CustomsControlForm } from './CustomsControlForm'
import { CustomIntermediatePointForm } from 'components/Order/OrderForms/OrderForm/OrderPointsForm/OrderPointsGroupForm/OrderPointForm/CustomIntermediatePointForm'
import { CheckboxField } from 'components/Shared/CheckboxField'
import sections from 'components/Order/sections'
import { mapToArray } from 'constants/utils'
import { CustomFieldsFormColumn } from 'components/CustomFields/CustomFieldsColumn/CustomFieldsFormColumn'

export function OrderPointForm ({
  number,
  name,
  disabled,
  arrowUpDisplayed,
  onArrowUpClick,
  arrowDownDisplayed,
  onArrowDownClick,
  onRemoveClick,
  onFerryPassageChanged,
  footer
}) {
  const { t } = useTranslation()

  const [, meta] = useField(name)
  const { value } = meta

  const pointSection = useMemo(() => mapToArray(sections).find(type => type.value === value.type), [value.type])

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <div className={styles.titleContainer}>
          <div className={styles.numberBox}>{number}</div>
          <div className={styles.titleBox}>{t(pointSection?.label)}</div>
        </div>
        <div className={styles.line}/>
        <div className={styles.utilityButtonsContainer}>
          {value.type === OrderPointType.FerryPassage &&
            <CheckboxField name={`${name}.visibleForClient`} disabled={disabled}
                           label="form.order.cargo.ferryPassageVisibleForClient"/>
          }
          {value.type === OrderPointType.Custom &&
            <CheckboxField name={`${name}.visibleForClient`} disabled={disabled}
                           label="form.order.cargo.customIntermediatePointVisibleForClient"/>
          }
          {value.type === OrderPointType.CustomsControl &&
            <CheckboxField name={`${name}.visibleForClient`} disabled={disabled}
                           label="form.order.cargo.customsControlVisibleForClient"/>
          }
          {arrowUpDisplayed && !disabled &&
            <IconButton
              onClick={() => onArrowUpClick()}
              icon={<UpIcon/>}/>
          }
          {arrowDownDisplayed && !disabled &&
            <IconButton
              onClick={() => onArrowDownClick()}
              icon={<DownIcon/>}/>
          }
          {!disabled && <IconButton
            onClick={() => onRemoveClick()}
            icon={<TrashIcon/>}/>
          }
        </div>
      </div>
      <div className={styles.body}>
        {
          {
            [OrderPointType.Loading]: () => <DeliveryPointForm name={`${name}.deliveryPointDetails`}
                                                               disabled={disabled}/>,
            [OrderPointType.Unloading]: () => <DeliveryPointForm name={`${name}.deliveryPointDetails`}
                                                                 disabled={disabled}/>,
            [OrderPointType.FerryPassage]: () => <FerryPassageForm name={`${name}.ferryPassageDetails`}
                                                                   onFerryPassageChanged={onFerryPassageChanged}
                                                                   disabled={disabled}/>,
            [OrderPointType.CustomsControl]: () => <CustomsControlForm name={`${name}.customsControlDetails`}
                                                                       disabled={disabled}/>,
            [OrderPointType.Custom]: () => <CustomIntermediatePointForm
              name={`${name}.customIntermediatePointDetails`}
              disabled={disabled}/>
          }[value.type]()
        }
        <div className={styles.customFieldsColumn}>
          <CustomFieldsFormColumn section={pointSection} disabled={disabled}/>
        </div>
      </div>
      {footer && (<div className={styles.footer}>{footer}</div>)}
    </div>
  )
}
